import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Button from "@mui/material/Button";
import paginationFactory from "react-bootstrap-table2-paginator";
import BootstrapTable from "react-bootstrap-table-next";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import { rfqdetail } from "../../constant/dummyData2";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { detailrfqproject } from "../../constant/dummyData2";
import checkImage from "../../assests/images/check-circle.png";
const style1 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
function RfqDetail() {
  const requestPayloadInitials = {
    pageNumber: 1,
    pageSize: 10,
    sortArray: [],
    searchCriteria: [],
  };
  const [openrfqdetailsubmitmodal, setOpenRfqDetailSubmitModal] =
    useState(false);
  const [openeditboqtriggermodal, setOpeneditBoqTriggerModal] = useState(false);
  const [opendownloaddetailrfqmodal, setOpenDownloadDetailRfqModal] =
    useState(false);
  const [opendownloadsuccessfullymodal, setOpenDownloadSuccessfullyModal] =
    useState(false);
  const [openextendvendormodaldetail, setOpenExtendVendorModalDetail] =
    useState(false);
  const [opentechnicalevaluation, setOpenTechnicalEvaluation] = useState(false);
  const [requestPayload, setRequestPayload] = useState(requestPayloadInitials);
  const handleTableChange = (
    type,
    { page, sizePerPage, sortField, sortOrder, filters, data }
  ) => {
    if (type === "pagination") {
      setRequestPayload({
        ...requestPayload,
        pageNumber: page,
        pageSize: sizePerPage,
      });
    }
    if (type == "sort") {
      setRequestPayload({
        ...requestPayload,
        sortArray: [sortField, sortOrder],
      });
      // const requestPayload = {
      //   ...this.state.requestPayload,
      //   sortArray: [sortField + "," + sortOrder],
      // };
      // this.getRoleWiseSOList(requestPayload);
      // this.props.getSalesOrderList(requestPayload);
      // this.setState({
      //   sorting: true,
      // })
    }
    if (type == "filter") {
      // const requestPayload = { ...this.state.requestPayload };
      // let secondSearchCriteriaArr = [];
      // // let secondSearchCriteriaArr = Object.keys(filters).map((ele) => {
      // //   let obj = {
      // //     key: ele,
      // //     value: filters[ele].filterVal,
      // //     operation: filters[ele].comparator,
      // //   };
      // //   return obj;
      // // });
    }
  };
  const columns = [
    {
      dataField: "Checkbox",
      text: "Select",
      formatter: (cell, row) => {
        return <input type="checkbox" id={row._id} />;
      },
    },
    {
      dataField: "itemno",
      text: `Item No`,
      sort: true,
    },
    {
      dataField: "Text",
      text: "Description",
      formatter: (cell, row) => {
        return (
          <input
            className="form-control form-haswe"
            type="text"
            placeholder="New Product Matrial"
            disabled
          />
        );
      },
    },
    {
      dataField: "text",
      text: `HSN/SAC Code`,
      formatter: (cell, row) => {
        return (
          <input
            className="form-control form-haswe"
            type="text"
            placeholder="GHSJ6781"
            disabled
          />
        );
      },
    },

    {
      dataField: "text",
      text: "Units",
      formatter: (cell, row) => {
        return (
          <input
            className="form-control form-haswe"
            type="text"
            placeholder={row?.uniysPlaceholder ?? ""}
            disabled
          />
        );
      },
    },

    {
      dataField: "text",
      text: "Quantity",
      formatter: (cell, row) => {
        return (
          <input
            className="form-control form-haswe"
            type="text"
            placeholder={row?.quantityPlaceholder ?? ""}
          />
        );
      },
    },
    {
      dataField: "text",
      text: "Rate (in INR)",
      formatter: (cell, row) => {
        return (
          <input
            className="form-control form-haswe"
            type="text"
            placeholder="XXXX"
            disabled
          />
        );
      },
    },

    {
      dataField: "text",
      text: "Amount (In INR)",
      formatter: (cell, row) => {
        return (
          <input
            className="form-control form-haswe"
            type="text"
            placeholder="XXXX"
            disabled
          />
        );
      },
    },
    {
      dataField: "text",
      text: "Remarks",
      formatter: (cell, row) => {
        return (
          <input
            className="form-control form-haswe"
            type="text"
            placeholder=""
            disabled
          />
        );
      },
    },
    {
      dataField: "text",
      text: "",
      formatter: (cell, row) => {
        return <HighlightOffIcon className="highlight_close_btn" />;
      },
    },

    // {
    //   dataField: "action",
    //   text: "Action",
    //   events: {
    //     onChange: (e, column, columnIndex, row, rowIndex) => {},
    //   },
    //   formatter: (cell, row, rowIndex) => {
    //     return (
    //       <div className="d-flex">
    //         <div className="vendor-action"> View </div>
    //         <div className="vendor-action"> | Edit </div>
    //         <div className="vendor-action"> | Update Status </div>
    //       </div>
    //     );
    //   },
    // },
  ];
  const columns1 = [
    {
      dataField: "Checkbox",
      text: "Select",
      formatter: (cell, row) => {
        return <input type="checkbox" id={row._id} />;
      },
    },

    {
      dataField: "vendorses",
      text: "Vendors",

      sort: true,
    },
    {
      dataField: "categoryy",
      text: `Category`,
      sort: true,
    },

    {
      dataField: "technicalevaluationstatus",
      text: "Technical Evaluation Status",
      sort: true,
    },
    {
      dataField: "participationn",
      text: "Participation",
      sort: true,
    },

    // {
    //   dataField: "action",
    //   text: "Action",
    //   events: {
    //     onChange: (e, column, columnIndex, row, rowIndex) => {},
    //   },
    //   formatter: (cell, row, rowIndex) => {
    //     return (
    //       <div className="d-flex">
    //         <div className="vendor-action"> View </div>
    //         <div className="vendor-action"> | Edit </div>
    //         <div className="vendor-action"> | Update Status </div>
    //       </div>
    //     );
    //   },
    // },
  ];
  return (
    <>
      <div className="login-forms">
        <div className="text-centers">
          <div className="search_filter_outerse ms-auto">
            <div className="search_main">
              <h5>RFQ Detail </h5>
            </div>
            <div class="timer_rfq_validity">
              <div class="timer-container">
                <div class="timer-label">Timer</div>

                <div class="timer-box">
                  <div class="timer-number">12</div>
                  <div class="timer-text">Day</div>
                </div>

                <div class="timer-box">
                  <div class="timer-number">18</div>
                  <div class="timer-text">Hours</div>
                </div>

                <div class="timer-box">
                  <div class="timer-number">45</div>
                  <div class="timer-text">Minutes</div>
                </div>

                <div class="timer-box">
                  <div class="timer-number">20</div>
                  <div class="timer-text">Seconds</div>
                </div>
              </div>

              <div class="date-picker-container">
                <form>
                  <div class="date-range">
                    <label class="rfq-label" for="rfqValidity">
                      RFQ Validity:
                    </label>
                    <div className="lets_rfq_detail_bidding">
                      <div class="from">
                        <label for="fromDate">From:</label>
                        <input
                          className="form-control form-haswe"
                          type="date"
                          id="fromDate"
                          name="fromDate"
                        />
                      </div>
                      <div class="to">
                        <label for="toDate">To:</label>
                        <input
                          className="form-control form-haswe"
                          type="date"
                          id="toDate"
                          name="toDate"
                        />
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>

          <div class="search_filter_outers ms-auto">
            <div class="seclected_form_detail_first1">
              <h5>BOQ</h5>
              <h5>Purchase Type</h5>
              <select
                class="form-select .seclected_form_detail_first1"
                aria-label="Default select example"
                fdprocessedid="zlera"
              >
                <option selected="">Service</option>
                <option value="1">Service</option>
                <option value="2">Service</option>
              </select>
            </div>

            <div class="extend_vendor_react_filter_div down_teh_comer">
              <div class="extend_vendor_react_filter_div">
                <button
                  onClick={() => {
                    setOpenExtendVendorModalDetail(true);
                  }}
                  type="button"
                  class="btn btn-light"
                >
                  Extend Vendnor
                </button>
                <button
                  onClick={() => {
                    setOpenDownloadDetailRfqModal(true);
                  }}
                  type="button"
                  class="btn btn-light"
                >
                  Download
                </button>
                <button
                  onClick={() => {
                    setOpenTechnicalEvaluation(true);
                  }}
                  type="button"
                  class="btn btn-light"
                >
                  Technical Evaluation
                </button>
                <button type="button" class="btn btn-light">
                  <Link
                    style={{ color: "black", textDecoration: "none" }}
                    to="/admin/Buyer-Bidding-Commercial-Evaluation"
                  >
                    Commercial Evaluation
                  </Link>
                </button>
                <button
                  onClick={() => {
                    setOpeneditBoqTriggerModal(true);
                  }}
                  type="button"
                  class="btn btn-light"
                >
                  Edit BOQ
                </button>
              </div>
            </div>
          </div>
          <div className="react-bootstrap-table-packageliisting">
            <BootstrapTable
              remote={{ search: true, pagination: true, sort: true }}
              bootstrap4
              keyField="id"
              data={rfqdetail}
              columns={columns}
              sort={true}
              // pagination={paginationFactory()}
              onTableChange={handleTableChange}
              noDataIndication={"No Data Found"}
              pagination={paginationFactory({
                page:
                  requestPayload.pageNumber == 0
                    ? 1
                    : requestPayload.pageNumber,
                sizePerPage: requestPayload.pageSize,
                totalSize: rfqdetail?.totalItems,
                showTotal: true,
                pageStartIndex: 1,
                paginationSize: 2,
              })}
            />
          </div>
          <div>
            <Button tabindex="0" type="button" fdprocessedid="9un26w">
              + Add Row
              <span class="MuiTouchRipple-root css-8je8zh-MuiTouchRipple-root"></span>
            </Button>
          </div>
          <div>
            <label>Remarks</label>
            <input className="form-control form-hasw" type="text" />
          </div>

          <div class="listing_block_maine_allbtn">
            <div className="package_detail_allbtn_projectmanager">
              <div>
                <p className="package_projectmanager">BOM</p>
                <div
                  class="selected-file-present-div"
                  style={{ display: "inline" }}
                >
                  <span class="selected-file-present-text">Document: 1 </span>
                </div>
                <button class="file-upload-btn">View</button>
                {/* <div className="lets_block_package_listing_bom_file">
                  <button className="upload_file_bom_tendor_project_react">
                    <CloudDownloadIcon className="download_icon_react" />
                    Upload File
                  </button>
                  <p>
                    {" "}
                    <CloudDownloadIcon className="download_icon_react" />
                    Download{" "}
                  </p>
                </div> */}
              </div>
              <div>
                <p className="package_projectmanager">Tendor Drawing </p>
                <div
                  class="selected-file-present-div"
                  style={{ display: "inline" }}
                >
                  <span class="selected-file-present-text">Document: 1 </span>
                </div>
                <button class="file-upload-btn">View</button>
              </div>
              <div>
                <p className="package_projectmanager">
                  Technical Specification{" "}
                </p>
                <div
                  class="selected-file-present-div"
                  style={{ display: "inline" }}
                >
                  <span class="selected-file-present-text">Document: 1 </span>
                </div>
                <button class="file-upload-btn">View</button>
              </div>
              <div>
                <p className="package_projectmanager">Make List Upload </p>
                <div
                  class="selected-file-present-div"
                  style={{ display: "inline" }}
                >
                  <span class="selected-file-present-text">Document: 1 </span>
                </div>
                <button class="file-upload-btn">View</button>
              </div>
              <div>
                <p className="package_projectmanager">
                  Resource Mobilisation Schedule{" "}
                </p>
                <div
                  class="selected-file-present-div"
                  style={{ display: "inline" }}
                >
                  <span class="selected-file-present-text">Document: 1 </span>
                </div>
                <button class="file-upload-btn">View</button>
              </div>
            </div>
          </div>
          <div class="listing_block_maine_allbtn2">
            <div className="package_detail_allbtn_projectmanager2">
              <div>
                <p className="package_projectmanager">Term Sheet</p>
                <div
                  class="selected-file-present-div"
                  style={{ display: "inline" }}
                >
                  <span class="selected-file-present-text">Document: 1 </span>
                </div>
                <button class="file-upload-btn">View</button>
              </div>
              <div>
                <p className="package_projectmanager">
                  List of Construction Materials{" "}
                </p>
                <div
                  class="selected-file-present-div"
                  style={{ display: "inline" }}
                >
                  <span class="selected-file-present-text">Document: 1 </span>
                </div>
                <button class="file-upload-btn">View</button>
              </div>
              <div>
                <p className="package_projectmanager">Vendor Information </p>
                <div
                  class="selected-file-present-div"
                  style={{ display: "inline" }}
                >
                  <span class="selected-file-present-text">Document: 1 </span>
                </div>
                <button class="file-upload-btn">View</button>
              </div>
              <div>
                <p className="package_projectmanager">
                  General Conditions of Contract{" "}
                </p>
                <div
                  class="selected-file-present-div"
                  style={{ display: "inline" }}
                >
                  <span class="selected-file-present-text">Document: 1 </span>
                </div>
                <button class="file-upload-btn">View</button>
              </div>
              <div>
                <p className="package_projectmanager">ABAC Policy </p>
                <div
                  class="selected-file-present-div"
                  style={{ display: "inline" }}
                >
                  <span class="selected-file-present-text">Document: 1 </span>
                </div>
                <button class="file-upload-btn">View</button>
                {/* <div className="lets_block_package_listing_bom_file">
                  <button className="upload_file_bom_tendor_project_react">
                    <InsertDriveFileIcon className="download_icon_react" />{" "}
                    File.pdf
                  </button>
                  <p>
                    {" "}
                    <HighlightOffIcon className="highlight_close_btn" />
                  </p>
                </div> */}
              </div>
              <div>
                <p className="package_projectmanager">Avaada Quality </p>
                <div
                  class="selected-file-present-div"
                  style={{ display: "inline" }}
                >
                  <span class="selected-file-present-text">Document: 1 </span>
                </div>
                <button class="file-upload-btn">View</button>
              </div>
            </div>
          </div>
          <div className="react-bootstrap-table-projectmanager">
            <BootstrapTable
              remote={{ search: true, pagination: true, sort: true }}
              bootstrap4
              keyField="id"
              data={detailrfqproject}
              columns={columns1}
              sort={true}
              // pagination={paginationFactory()}
              onTableChange={handleTableChange}
              noDataIndication={"No Data Found"}
              pagination={paginationFactory({
                page:
                  requestPayload.pageNumber == 0
                    ? 1
                    : requestPayload.pageNumber,
                sizePerPage: requestPayload.pageSize,
                totalSize: detailrfqproject?.totalItems,
                showTotal: true,
                pageStartIndex: 1,
                paginationSize: 2,
              })}
            />
          </div>

          <div class="closebtn_submit_block_btn">
            <button
              type="button"
              class="btn clear_btn_status_block_lists"
              fdprocessedid="wshspp"
            >
              Close
            </button>
            <button
              onClick={() => {
                setOpenRfqDetailSubmitModal(true);
              }}
              type="button"
              class="btn btn-success save_next_btns"
            >
              Submit
            </button>
          </div>
          {/* RFQ Detail Submit Modal  */}
          <Modal
            open={openrfqdetailsubmitmodal}
            onClose={() => setOpenRfqDetailSubmitModal(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenRfqDetailSubmitModal(false)}
                ></button>
              </div>
              <div class="modal-bodys">
                <from>
                  <div className="approvel_btn_successfully">
                    <img src={checkImage} alt="" />
                    <p>
                      RFQ No. XXX has been created <br />
                      successfully
                    </p>
                    <p></p>
                    <button type="button" class="btn btn-success save_next_btn">
                      <Link
                        style={{ color: "white", textDecoration: "none" }}
                        to="/admin/Engineering-Bidding-Rfq-Listing"
                      >
                        Done
                      </Link>
                    </button>
                  </div>
                </from>
              </div>
            </Box>
          </Modal>
          {/* Technical Evaluation status Modal */}
          <Modal
            open={opentechnicalevaluation}
            onClose={() => setOpenTechnicalEvaluation(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenTechnicalEvaluation(false)}
                ></button>
              </div>
              <div class="modal-bodys">
                <from>
                  <div className="approvel_btn_successfully">
                    <h3 class="evaluation_block">Technical Evaluation</h3>
                    <p>
                      Are you sure you want to initiate the technical
                      evaluation.
                      <br /> 2/8 vendors are still pending to submit their
                      Technical Proposal
                    </p>
                    <p></p>
                    <div className="lets_no_btn_danger_yes_technical_project">
                      <button
                        onClick={() => {
                          setOpenTechnicalEvaluation(false);
                        }}
                        type="button"
                        class="btn btn btn-danger"
                      >
                        No
                      </button>
                      <button type="button" class="btn btn-success">
                        <Link
                          style={{ color: "white", textDecoration: "none" }}
                          to="/admin/Engineering-Bidding-Technical-Evaluation"
                        >
                          Yes
                        </Link>
                      </button>
                    </div>
                  </div>
                </from>
              </div>
            </Box>
          </Modal>
          {/* Edit BOQ   Modal  */}
          <Modal
            open={openeditboqtriggermodal}
            onClose={() => setOpeneditBoqTriggerModal(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpeneditBoqTriggerModal(false)}
                ></button>
              </div>
              <div class="modal-bodys">
                Are you sure you want to modify BOQ, this will trigger
                notification to Engineer once modified.
                <div class="clear_btn_status_modified_boq">
                  <button type="button" class="btn btn-secondary">
                    No
                  </button>
                  <button type="button" class="btn btn-success">
                    Yes
                  </button>
                </div>
              </div>
            </Box>
          </Modal>
          {/* RFQ Detail Extend Vendor Modal  */}
          <Modal
            open={openextendvendormodaldetail}
            onClose={() => setOpenExtendVendorModalDetail(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenExtendVendorModalDetail(false)}
                ></button>
              </div>
              <div class="modal-bodys">
                <from>
                  <div className="approvel_btn_successfully">
                    <img src={checkImage} alt="" />
                    <h6>Extend Vendor Invitiation</h6>
                    <p>
                      On Approval of this RFQ, the bidding process will be
                      initiated <br />& invite will be published to respective
                      Vendors
                    </p>
                    <p>Do you want to continue?</p>
                    <div class="clear_btn_status_modified_boq">
                      <button type="button" class="btn btn-secondary">
                        No
                      </button>
                      <button type="button" class="btn btn-success">
                        Yes
                      </button>
                    </div>
                  </div>
                </from>
              </div>
            </Box>
          </Modal>
          {/* RFQ Detail Download Modal  */}
          <Modal
            open={opendownloaddetailrfqmodal}
            onClose={() => setOpenDownloadDetailRfqModal(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel">
                  Download Result
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenDownloadDetailRfqModal(false)}
                ></button>
              </div>
              <div class="modal-body ">
                <from>
                  <div className="approvel_btn_successfullys_detail">
                    <div className="pdf_download_modal_react">
                      <input type="radio" />
                      <p>Pdf</p>
                    </div>

                    <div className="pdf_download_modal_react">
                      <input type="radio" />
                      <p>Excel</p>
                    </div>
                    <div className="pdf_download_modal_react">
                      <input type="radio" />
                      <p>Both</p>
                    </div>
                    <div className="clear_btn_result_btn_evaluation">
                      <button
                        type="button"
                        class="btn clear_btn_status_block_lists"
                      >
                        Clear
                      </button>
                      <button
                        type="button"
                        class="btn btn-success save_next_btns"
                        onClick={() => {
                          setOpenDownloadDetailRfqModal(false);
                          setOpenDownloadSuccessfullyModal(true);
                        }}
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </from>
              </div>
            </Box>
          </Modal>
          {/* RFQ Detail Download Successfully Modal  */}
          <Modal
            open={opendownloadsuccessfullymodal}
            onClose={() => setOpenDownloadSuccessfullyModal(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel">
                  Download Result
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenDownloadSuccessfullyModal(false)}
                ></button>
              </div>
              <div class="modal-body ">
                <from>
                  <div className="approvel_btn_successfullys">
                    <img src={checkImage} alt="" />
                    <p>Congratulations! Your download is complete.</p>

                    <div className="clear_btn_result_btn_evaluation ">
                      <button
                        type="button"
                        class="btn btn-success save_next_btns"
                      >
                        Done
                      </button>
                    </div>
                  </div>
                </from>
              </div>
            </Box>
          </Modal>
        </div>
      </div>
    </>
  );
}

export default RfqDetail;
